var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDataUsage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 2.05005V5.08005C16.39 5.57005 19 8.47005 19 12C19 12.9 18.82 13.75 18.52 14.54L21.12 16.07C21.68 14.83 22 13.45 22 12C22 6.82005 18.05 2.55005 13 2.05005ZM12 19C8.13 19 5 15.87 5 12C5 8.47005 7.61 5.57005 11 5.08005V2.05005C5.94 2.55005 2 6.81005 2 12C2 17.52 6.47 22 11.99 22C15.3 22 18.23 20.39 20.05 17.91L17.45 16.38C16.17 17.98 14.21 19 12 19Z",
    fill: "#323232"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataUsage);
export default __webpack_public_path__ + "static/media/data_usage.c8444c8f.svg";
export { ForwardRef as ReactComponent };